exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host > * {\n  display: -ms-grid;\n  display: grid;\n  padding: var(--padding);\n  gap: var(--padding);\n  -ms-grid-columns: max-content 1fr;\n      grid-template-columns: max-content 1fr; }\n  :host > * label,\n  :host > * legend {\n    text-align: right; }\n  :host > * input[type='radio'] + label {\n    text-align: left; }\n  :host > * ul > li {\n    display: -ms-grid;\n    display: grid;\n    gap: var(--padding);\n    -ms-grid-columns: max-content 1fr;\n        grid-template-columns: max-content 1fr;\n    -ms-flex-align: center;\n        align-items: center; }\n  :host > * div {\n    -ms-grid-column-span: 2;\n    -ms-grid-column: auto;\n        grid-column: auto / span 2;\n    display: -ms-flexbox;\n    display: flex;\n    place-content: center;\n    gap: var(--padding); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/project/project-edit/project-edit.component.scss
// module id = ../../../../../src/app/project/project-edit/project-edit.component.scss
// module chunks = main